import { createHashRouter } from "react-router-dom";
import { ProtectedRoute } from "./ProtectedRoute";
import { ProtectedRouteNoLayout } from "./ProtectedRouteNoLayout";
import Root from "./Root";
import ForgotPassword from "./pages/auth/forgot_pasword/ForgotPassword";
import VerifyEmail from "./pages/auth/forgot_pasword/VerifyEmail";
import NewPassword from "./pages/auth/forgot_pasword/NewPassword";
import LoginOtpCode from "./pages/auth/LoginOtpCode";
import PasswordResetSuccess from "./pages/auth/forgot_pasword/PasswordResetSuccess";
import MyWallet from "./pages/wallets/MyWallet";
import MyWalletView from "./pages/wallets/MyWalletView";
import SandBox from "./pages/admin/Sandbox";
import UsersList from "./pages/users/UsersList";
import C2BTable from "./pages/payment/C2B/C2BTable";
import RegistrationSuccess from "./pages/auth/registration_steps/RegistrationSuccess";
import KybDocuments from "./pages/auth/verification_documents/KybDocuments";
import DirectPaymentTable from "./pages/payment/direct_payment/DirectPaymentTable";
import PaymentDetailsTable from "./pages/payment/direct_payment/details/PaymentDetailsTable";
import BulkPaymentTable from "./pages/payment/bulk-payment/BulkPaymentTable";
import VerificationTable from "./pages/payment/bulk-payment/modal/VerificationTable";
import BulkPaymentDetailsTable from "./pages/payment/bulk-payment/details/BulkPaymentDetailsTable";
import KyuDocuments from "./pages/auth/verification_documents/KyuDocuments";
import UserAddList from "./pages/users/user_add/UserAddList";
import Register from "./pages/auth/Register";
import GroupFolderTable from "./pages/payment/groups_/GroupFolderTable";
import ContactsListView from "./pages/payment/groups_/ContactsListView";
import MembersUploadList from "./pages/payment/groups_/MembersUploadList";
import FundsTransferList from "./pages/funds-transfer/FundsTransferList";
import TransferApproval from "./pages/approvals/TransferApproval";
import PaymentAprConfTable from "./pages/setup/payment/PaymentAprConfTable";
import GroupPaymentTable from "./pages/payment/group-payments/GroupPaymentTable";
import GroupPaymentDetailsTable from "./pages/payment/group-payments/details/GroupPaymentDetailsTable";
import UtilityTable from "./pages/setup/utility/UtilityTable";
import DashboardList from "./pages/dashboard/DashboardList";
import SettlementTable from "./pages/setup/settlement/SettlementTable";
import AddressDetailsStep from "./pages/auth/registration_steps/AddressDetailsStep";
import ProfileList from "./pages/profile/ProfileList";
import OtpVerificationTable from "./pages/setup/otp-verification/OtpVerificationTable";
import MainReports from "./pages/reports/MainReports";
import PaymentApproval from "./pages/approvals/PaymentApproval";
import Groups from "./pages/payment/groups/Groups";
import Account from "./pages/account/Account";
import SettlementApproval from "./pages/approvals/SettlementApproval";
import AccountTabs from "./pages/admin/company-account/AccountTabs";
import PaymentSummary from "./pages/payment/summary/PaymentSummary";
import SubCategoryTable from "./pages/setup/sub-category/SubCategoryTable";
import CategoryTable from "./pages/setup/category/CategoryTable";
import MessageTemplate from "./pages/settings/templates/MessageTemplate";
import StandingOrderTable from "./pages/payment/standing-order/StandingOrderTable";
import PaybillTable from "./pages/setup/paybill/PaybillTable";
import ChooseScreen from "./pages/auth/ChooseScreen";
import LoginEmail from "./pages/auth/LoginEmail";
import SelectOrganization from "./pages/auth/SelectOrganization";
import LoginPassword from "./pages/auth/LoginPassword";
import Landing from "./pages/landing/Landing";
import StandingOrderDetailsTable from "./pages/payment/standing-order/details/StandingOrderDetailsTable";

export const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      {
        path: "/",
        element: <Landing />,
        index: true,
      },
      {
        path: "/landing",
        element: <Landing />,
      },

      {
        path: "/login",
        element: <LoginEmail />,
      },
      {
        path: "/select-organization",
        element: <SelectOrganization />,
      },

      {
        path: "/login-password",
        element: <LoginPassword />,
      },
      {
        path: "/registration",
        element: <Register />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/verify-email",
        element: <VerifyEmail />,
      },
      {
        path: "/new-password",
        element: <NewPassword />,
      },
      {
        path: "/login-otp",
        element: <LoginOtpCode />,
      },
      {
        path: "/password-reset-success",
        element: <PasswordResetSuccess />,
      },
      {
        path: "/registration-success",
        element: <RegistrationSuccess />,
      },
      {
        path: "/kyu-documents",
        element: <KyuDocuments />,
      },
      {
        path: "/kyb-documents",
        element: <KybDocuments />,
      },
      // Protected route WITHOUT sidebar/header for choose-screen
      {
        element: <ProtectedRouteNoLayout />,
        children: [
          {
            path: "/choose-screen",
            element: <ChooseScreen />,
          },
        ],
      },
      // Protected routes WITH sidebar for all other authenticated pages
      {
        element: <ProtectedRoute role={"EXECUTIVE"} />,
        children: [
          {
            path: "/my-wallet",
            element: <MyWallet />,
          },
          {
            path: "/sandbox",
            element: <SandBox />,
          },
          {
            path: "/my-wallet-view",
            element: <MyWalletView />,
          },
          {
            path: "/users",
            element: <UsersList />,
          },
          {
            path: "/c2b",
            element: <C2BTable />,
          },
          {
            path: "/direct-payment",
            element: <DirectPaymentTable />,
          },
          {
            path: "/payment-details",
            element: <PaymentDetailsTable />,
          },
          {
            path: "/bulk-payment",
            element: <BulkPaymentTable />,
          },
          {
            path: "/group-payment",
            element: <GroupPaymentTable />,
          },
          {
            path: "/bulk-verification",
            element: <VerificationTable />,
          },
          {
            path: "/bulk-payment-details",
            element: <BulkPaymentDetailsTable />,
          },
          {
            path: "/group-payment-details",
            element: <GroupPaymentDetailsTable />,
          },
          {
            path: "/users-add-list",
            element: <UserAddList />,
          },
          {
            path: "/contacts/folders/list/:name",
            element: <ContactsListView />,
          },
          {
            path: "/group-members/upload",
            element: <MembersUploadList />,
          },
          {
            path: "/funds-transfer",
            element: <FundsTransferList />,
          },
          {
            path: "/transfer-approval",
            element: <TransferApproval />,
          },
          {
            path: "/payment-approval-setup",
            element: <PaymentAprConfTable />,
          },
          {
            path: "/utility-setup",
            element: <UtilityTable />,
          },
          {
            path: "/dashboard",
            element: <DashboardList />,
          },
          {
            path: "/settlement-setup",
            element: <SettlementTable />,
          },
          {
            path: "/profile",
            element: <ProfileList />,
          },
          {
            path: "/otp-verification-setup",
            element: <OtpVerificationTable />,
          },
          {
            path: "/payment-category",
            element: <CategoryTable />,
          },
          {
            path: "/payment-sub-category",
            element: <SubCategoryTable />,
          },
          {
            path: "/reports",
            element: <MainReports />,
          },
          {
            path: "/payments-approval",
            element: <PaymentApproval />,
          },
          {
            path: "/groups",
            element: <Groups />,
          },
          {
            path: "/group-setup",
            element: <GroupFolderTable />,
          },
          {
            path: "/user-account-profile",
            element: <Account />,
          },
          {
            path: "/company-account-profile",
            element: <AccountTabs />,
          },
          {
            path: "/settlement-approval",
            element: <SettlementApproval />,
          },
          {
            path: "/summary",
            element: <PaymentSummary />,
          },
          {
            path: "/message-template",
            element: <MessageTemplate />,
          },
          {
            path: "/paybill-list",
            element: <PaybillTable />,
          },
          {
            path: "/standing-order",
            element: <StandingOrderTable />,
          },
          {
            path: "/standing-details",
            element: <StandingOrderDetailsTable />,
          },
        ],
      },
      {
        path: "*",
        element: <p>404 - Error: Page not found</p>,
      },
    ],
  },
]);
